import ComponentIcon from '@material-ui/icons/DeleteForever';
import { Component } from 'react';

class DeleteForeverIcon extends Component {
  render() {
    const defaultStyle = {
      fill: '#323C32',
      margin: '0px',
      height: '20px',
      width: '20px',
    };

    const mergedStyle = {
      ...defaultStyle,
      ...this.props.style,
    };

    return (
      <ComponentIcon
        {...this.props}
        style={mergedStyle}
        viewBox='0 2.5 20 20'
      />
    );
  }
}

export default DeleteForeverIcon;
